import React from "react";
import { useLocation } from "react-router-dom";
import { T } from "services/lang/LanguageService";

const NotFound = () => {
  const location = useLocation().pathname;
  return (
    <div
      style={{
        maxWidth: "600px",
        margin: "0 auto",
        marginTop: "20px",
      }}
    >
      <h1>
        {T("label.not-found.page-not-found")}: {location}
      </h1>
      <p>
        {T("message.not-found.the-page-you-are-looking-for-does-not-exist-please-check-the-url-or")}&nbsp;
        <button type="button" className="text-blue-500 underline" onClick={() => window.history.back()}>
          {T("action.go-back")}
        </button>
        .
      </p>
    </div>
  );
};

export default NotFound;
